import(/* webpackMode: "eager" */ "/home/ubuntu/download/698660ba921dc90014fe0c75/website_project/src/app/order/page.tsx");
